import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import avo from 'analytics/avo';
import SSRSafeElement from 'commons/SSRSafeElement';
import Link from 'components/consumer/Link';
import StatusLabel from 'components/consumer/StatusLabel';
import IconArrowRightSimple from 'components/icons/iconArrowRightSimple';
import useKeyboardControlForDropdown from 'hooks/useKeyboardControlForDropdown';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
const DesktopNavLinkGroupItem = t0 => {
  const $ = _c(38);
  const {
    categoryId: t1,
    containerRef,
    hasNestedContent: t2,
    id,
    isNew,
    label,
    selectedItem,
    setIsTitleHovered,
    url
  } = t0;
  const categoryId = t1 === undefined ? "" : t1;
  const hasNestedContent = t2 === undefined ? false : t2;
  const toggleRef = useRef(null);
  const isSelected = id === selectedItem;
  const currentPage = useUserCurrentPageType();
  let t3;
  if ($[0] !== id || $[1] !== setIsTitleHovered) {
    t3 = () => {
      setIsTitleHovered(id, true);
    };
    $[0] = id;
    $[1] = setIsTitleHovered;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const open = t3;
  let t4;
  if ($[3] !== id || $[4] !== setIsTitleHovered) {
    t4 = () => {
      setIsTitleHovered(id, false);
    };
    $[3] = id;
    $[4] = setIsTitleHovered;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const close = t4;
  let t5;
  if ($[6] !== categoryId || $[7] !== id) {
    t5 = () => document.getElementById(`${categoryId}-${id}`);
    $[6] = categoryId;
    $[7] = id;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== close || $[10] !== containerRef || $[11] !== isSelected || $[12] !== open || $[13] !== t5) {
    t6 = {
      isOpen: isSelected,
      getPopupContainerElement: t5,
      toggleContainerRef: containerRef,
      toggleRef,
      open,
      close
    };
    $[9] = close;
    $[10] = containerRef;
    $[11] = isSelected;
    $[12] = open;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  useKeyboardControlForDropdown(t6);
  let t7;
  if ($[15] !== currentPage || $[16] !== label || $[17] !== url) {
    t7 = label === "Room Visualizer" || label === "Room Refresh" ? () => {
      avo.ctaClicked({
        text: label,
        targetUrl: url,
        cta: "Room Refresh",
        location: currentPage,
        component: "Navbar"
      });
    } : undefined;
    $[15] = currentPage;
    $[16] = label;
    $[17] = url;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = !isSelected;
  let t9;
  if ($[19] !== isSelected || $[20] !== t8) {
    t9 = classNames("text-sm font-bold items-center flex p-2.5 relative no-underline [transition:color_125ms_ease-in] xl:text-base xl:font-bold", "focus-visible:outline-offset-[-4px] focus-visible:!text-brand", "focus:!text-brand focus:!no-underline", "hover:!text-brand hover:!no-underline", {
      "!text-gray": t8,
      "!text-brand !no-underline": isSelected
    });
    $[19] = isSelected;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== label) {
    t10 = <span>{label}</span>;
    $[22] = label;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== isNew) {
    t11 = !!isNew && <StatusLabel className="ml-2">New</StatusLabel>;
    $[24] = isNew;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== hasNestedContent || $[27] !== isSelected) {
    t12 = !!hasNestedContent && <IconArrowRightSimple className={classNames("ml-2 relative", "group-hover/DesktopNavLinkGroupItem__link:opacity-100 group-hover/DesktopNavLinkGroupItem__link:transform-[translateX(0)] group-hover/DesktopNavLinkGroupItem__link:[transition:all_125ms_ease-out]", "group-focus/DesktopNavLinkGroupItem__link:opacity-100 group-focus/DesktopNavLinkGroupItem__link:transform-[translateX(0)] group-focus/DesktopNavLinkGroupItem__link:[transition:all_125ms_ease-out]", {
      "opacity-0 transform-[translateX(10px)] [transition:none]": !isSelected,
      "opacity-100 transform-[translateX(0)] [transition:all_125ms_ease-out]": isSelected
    })} width={6} height={10} color="currentColor" />;
    $[26] = hasNestedContent;
    $[27] = isSelected;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== close || $[30] !== open || $[31] !== t10 || $[32] !== t11 || $[33] !== t12 || $[34] !== t7 || $[35] !== t9 || $[36] !== url) {
    t13 = <li className="list-none"><Link to={url} onClick={t7} className={t9} onMouseEnter={open} onMouseLeave={close} ref={toggleRef}>{t10}{t11}{t12}</Link></li>;
    $[29] = close;
    $[30] = open;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
    $[34] = t7;
    $[35] = t9;
    $[36] = url;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
};
DesktopNavLinkGroupItem.propTypes = {
  categoryId: PropTypes.string,
  containerRef: PropTypes.shape({
    current: PropTypes.instanceOf(SSRSafeElement)
  }),
  hasNestedContent: PropTypes.bool,
  id: PropTypes.string.isRequired,
  isNew: PropTypes.bool,
  label: PropTypes.string.isRequired,
  selectedItem: PropTypes.string,
  setIsTitleHovered: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired
};
export default DesktopNavLinkGroupItem;